import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContactModel } from 'src/app/core/models/contact.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FilterByPipeModule } from '../../../pipes';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-individual-assignment',
    templateUrl: './individual-assignment.component.html',
    styleUrls: ['./individual-assignment.component.scss'],
    imports: [
      CommonModule, FormsModule, MatFormFieldModule,
      MatCheckboxModule, MatSelectModule,
      FilterByPipeModule, MatInputModule, MatButtonModule,
      FontAwesomeModule
    ],
    standalone: true
})
export class IndividualAssignmentComponent implements OnInit {
    @Input() selectedContacts: Array<ContactModel> = [];
    contactsFilter = '';
    isSelectedAll: boolean = false;
    selectType: boolean = true;
    @Input() optionsList = [];
    @Input() type;
    ids = [];
    @Output() exportIds: EventEmitter<any> = new EventEmitter<any>();
    showLinkCadence: boolean = false;
    ddSelectedItem;
    isShowDD = false;
    selectedContactCount = 0;
    crm = { outreach: { key: 'sequence', label: 'selectedSequence' }, salesloft: { key: 'cadence', label: 'selectedCadence' } }
    key;
    label;

    config = {
        displayKey: 'name', //if objects array passed which key to be displayed defaults to description
        search: true, //true/false for the search functionlity defaults to false,
        height: '30vh', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
        placeholder: 'Link Cadence', // text to be displayed when no item is selected defaults to Select,
        //customComparator: ()=>{} // a custom function using which user wants to sort the itemsnkedCa. default is undefined and Array.sort() will be used in that case,
        // limitTo: 5, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
        //moreText: 'more' // text to be displayed whenmore than one items are selected like Option 1 + 5 more
        noResultsFound: 'No cadences found!', // text to be displayed when no items are found while searching
        searchPlaceholder: 'Search', // label thats displayed in search input
        searchOnKey: 'name'
    }

    outreachConfig = {
        displayKey: 'name', //if objects array passed which key to be displayed defaults to description
        search: true, //true/false for the search functionlity defaults to false,
        height: 'auto', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
        placeholder: 'Link Sequence', // text to be displayed when no item is selected defaults to Select,
        //customComparator: ()=>{} // a custom function using which user wants to sort the itemsnkedCa. default is undefined and Array.sort() will be used in that case,
        limitTo: 5, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
        //moreText: 'more' // text to be displayed whenmore than one items are selected like Option 1 + 5 more
        noResultsFound: 'No sequences found!', // text to be displayed when no items are found while searching
        searchPlaceholder: 'Search', // label thats displayed in search input
        searchOnKey: 'name'
    }

    constructor() {

    }

    ngOnInit(): void {
        this.ids = this.selectedContacts.map(function (el: any) {
            el.selectedContact = false;
            return { id: el.matchId };
        });
        this.key = this.crm[this.type].key;
        this.label = this.crm[this.type].label;
    }

    checkIfSelectedAll() {
        setTimeout(() => {
            this.isSelectedAll = this.selectedContacts.every((item: any) => item.selectedContact === true);
            this.showLinkCadence = this.selectedContacts.filter(item => item['selectedContact'] === true).length > 1;
        })
    }

    toggleSelectAll(isSelectedAll: boolean) {
        this.isSelectedAll = isSelectedAll;
        this.selectedContacts.forEach(element => element['selectedContact'] = this.isSelectedAll);
        this.showLinkCadence = this.selectedContacts.length > 1 ? this.isSelectedAll : false;
        this.selectType = !this.selectType;
    }


    onClearAll() {
        this.selectedContacts.forEach(contact => {
            if (contact['selectedContact'] === true) {
                this.ids.filter(i => {
                    if (i.id === contact.matchId) {
                        delete i[this.key];
                    }
                })
                delete contact[this.label];
                contact['selectedContact'] = false;
            }
        });
        this.exportIds.emit(this.ids);
        this.showLinkCadence = false;
        this.selectType = true;
        this.isSelectedAll = false;
    }

    onClear(matchId) {
        this.selectedContacts.forEach(contact => {
            if (matchId) {
                if (matchId === contact.matchId) {
                    this.ids.filter(i => {
                        if (i.id === contact.matchId) {
                            delete i[this.key];
                        }
                    })
                    delete contact[this.label];
                }
            }
        });
    }

    onDDCadence() {
        // OPTIMIZE
        this.selectedContacts.forEach(contact => {
            if (contact['selectedContact'] === true) {
                contact[this.label] = this.ddSelectedItem.id;
                this.ids.forEach(i => {
                    if (i.id === contact.matchId) {
                        i[this.key] = this.ddSelectedItem.id
                    }
                });
                contact['selectedContact'] = false;
            }
        });
        this.exportIds.emit(this.ids);
        this.showLinkCadence = false;
        this.selectType = true;
        this.isSelectedAll = false;
        this.ddSelectedItem = null;
    }

    toggleDD() {
        if (this.isShowDD === false) {
            this.isShowDD = true;
        } else {
            this.isShowDD = false;
        }
    }

    onMapCadence(matchId, optionId) {
        if (optionId && matchId) {
            this.ids.forEach(i => {
                if (i.id === matchId) {
                    i[this.key] = optionId;
                }
            });
        }
        this.exportIds.emit(this.ids);
    }
}
